import React from "react";
const goalsData = [
  {
    id: 1,
    goal: "Through our retail outlet and the Waste-to-Fuel model, households in host communities can exchange recyclables as an alternative mode of payment for LPG, reducing their energy expenses by up to 30% and making clean energy both accessible and affordable.",
    image: "/images/goal7.png",
    invert: false,
    name: "GOAL 7",
    title: "Affordable and Clean Energy",
  },
  {
    id: 2,
    goal: "We supports SDG Goal 10 by reducing energy poverty and inequalities in rural communities by democratizing access to clean cooking energy through our Waste-to-Fuel system. With this, we are promoting equal rights to clean energy as a fundamental human right while also creating sustainable local jobs and improving economic opportunities.",
    image: "/images/Inequality+F.png",
    invert: true,
    name: "GOAL 10",
    title: "Reduced Inequalities",
  },
  {
    id: 3,
    goal: "We support SDG Goal 11 by creating an inclusive, safe, resilient, and sustainable community. We provide access to affordable clean cooking gas (LPG) to reduce reliance on biomass fuels and reduce the emission of black carbon into the atmosphere. With our Waste-to-Fuel program, we help community develop responsible waste management culture, reduce environmental pollution hereby creating a cleaner, and more sustainable communities.",
    image: "/images/sustainabile.png",
    invert: false,
    name: "GOAL 11",
    title: "Sustainable cities and communities",
  },
  {
    id: 4,
    goal: "With the establishment of our LPG retail hub and by implementing of our Waste-to-Fuel mechanism, we minimize waste pollution through responsible waste management, reduces dependence on biomass fuels to prevent deforestation, and promotes efficient, clean energy consumption.",
    image: "/images/production.png",
    invert: true,
    name: "GOAL 12",
    title: "Responsible Consumption and Production",
  },
  {
    id: 5,
    goal: "Our business operation in community help reduces greenhouse gas emissions, black carbon production, and reduces plastic waste pollution in rural communities.",
    image: "/images/climate.png",
    invert: false,
    name: "GOAL 13",
    title: "Climate Change",
  },
];
const SustainableDevelopmentGoalsAlignment = React.forwardRef((props, ref) => {
  return (
    <>
      <div ref={ref} className="bg-red-600 w-full py-8">
        <div className="w-[90%] mx-auto flex flex-col gap-7">
          <h1 className="text-3xl md:text-5xl text-[#fff]">
            Our Sustainable Development Goals Alignment
          </h1>
          <p className="text-2xl text-white">
            We are fully aligned and committed to the UN Sustainable Development
            Goals. We are focused on 5 SDG goals:
          </p>
          {goalsData.map((goal) => {
            return (
              <div
                key={goal.id}
                className={`md:grid md:grid-cols-2 gap-4 ${
                  goal.invert ? "grid-areas-reversed" : "grid-areas-normal"
                }`}
                style={{
                  gridTemplateAreas: goal.invert
                    ? "'image text'"
                    : "'text image'",
                }}
              >
                <div
                  className="flex flex-col gap-3 py-4"
                  style={{
                    gridArea: "text",
                  }}
                >
                  <div className="rounded-full px-4 py-2 w-fit h-fit bg-white font-semibold text-center">
                    {goal.name}
                  </div>
                  <h1 className="text-white md:text-4xl text-3xl">
                    {goal.title}
                  </h1>
                  <p className=" text-[#fff]">{goal.goal}</p>
                </div>

                <div className="md:flex hidden items-center h-full shadow-2xl">
                  <div className="w-[20px] bg-[#38761d] h-full"></div>
                  <div className="w-[10px] bg-[#f46524] h-full"></div>
                  <div
                    className=" h-[350px] w-full"
                    style={{
                      gridArea: "image",
                      backgroundImage: `url('${goal.image}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                    }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
});

export default SustainableDevelopmentGoalsAlignment;
